export const CARRY_OVER_SECTIONS = {
    ROB2: [
        {
            id: 'preliminary',
            label: 'Preliminary considerations',
            keys: [
                'preliminary.studyDesign',
                'preliminary.experimental',
                'preliminary.comparator',
                'preliminary.aim',
                'preliminary.deviationsToAddress',
                'preliminary.sources',
            ],
        },
        { id: 'domain1', label: 'Domain 1', prefixes: ['d1_', 'domain1.'] },
        {
            id: 'domain2',
            label: 'Domain 2',
            prefixes: ['d2a_', 'd2b_', 'domain2a.', 'domain2b.'],
            requiresMatch: ['preliminary.aim'],
        },
    ],
    ROBINS_I: [
        {
            id: 'planning',
            label: 'Planning and confounding factors',
            prefixes: ['planning.', 'confoundingEvaluation.'],
        },
        { id: 'sectionC', label: 'Section C', prefixes: ['sectionC.'] },
        { id: 'sectionD', label: 'Section D', prefixes: ['sectionD.'] },
        {
            id: 'domain1',
            label: 'Domain 1',
            prefixes: ['d1a_', 'd1b_', 'domain1a.', 'domain1b.'],
            requiresMatch: ['sectionC.isPerProtocol'],
        },
        { id: 'domain2', label: 'Domain 2', prefixes: ['d2_', 'domain2.'] },
        { id: 'domain3', label: 'Domain 3', prefixes: ['d3_', 'domain3.'] },
    ],
};
//# sourceMappingURL=carry-over.js.map